export default __webpack_public_path__ + "static/media/check-solid.49fb1db0.svg";